export default __webpack_public_path__ + "content/media/29.a28bee55.jpg";